import { formatToDecimals } from '@bg-shared/utils/formatToDecimals';
import { HttpClientFactory, HttpClientRepository } from '../../infrastructure/HttpClient';
import { IGameInitializationResponse, IGameConfig } from './interfaces';

export class RGSGameApi {
    protected client: HttpClientRepository;

    constructor() {
        this.client = HttpClientFactory.getRgsClient();
    }

    public loadGame(login: string, token: string): Promise<IGameInitializationResponse> {
        return this.client
            .get<IGameInitializationResponse>(login, {
                params: {
                    token,
                },
                transformRequest: false,
                transformResponse: false,
            })
            .then((response) => {
                response.gameSettings.customStakes =
                    response.gameSettings.customStakes.map(formatToDecimals);
                response.gameSettings.minStake = formatToDecimals(response.gameSettings.minStake);
                response.gameSettings.maxStake = formatToDecimals(response.gameSettings.maxStake);
                response.gameSettings.maxExposure = formatToDecimals(
                    response.gameSettings.maxExposure,
                );

                return response;
            });
    }

    public loadConfig(url: string, token: string): Promise<IGameConfig> {
        return this.client.post(url, {
            data: {
                token,
                op: 'loadConfig',
            },
            transformRequest: false,
            transformResponse: false,
        });
    }
}
